<template>
  <div>
    <modal-form v-model="show" size="xl" body-class="pa-0 pdf-visualizer" ref="modal" data-cy="pdf-form" :showSubmit="false" textClose="Fechar">
      <template v-slot:title>
        <slot name="title" data-cy="pdf-form-title">
          {{ title }}
        </slot>
      </template>
      <template v-slot:body>
        <form class="hidden" ref="form" method="post" target="iframe_imprimir"></form>
        <div class="holds-the-iframe" ref="container" data-cy="pdf-container">
          <iframe src="" ref="iframe_imprimir" name="iframe_imprimir" width="100%" type="application/pdf"></iframe>
        </div>
        <div v-show="showloading" style="height:0px" class="wait-loading"> </div>
      </template>
    </modal-form>
  </div>
</template>
<script>
export default {
  props: {
    title: { type: String, default: 'Visualizar' },
    url: { type: String, default: '' }
  },
  data () {
    return {
      show: false,

      showloading: true
    }
  },
  methods: {
    openModal (sender) {
      const th = this
      th.show = true
      th.submitForm()
    },
    submitForm () {
      const th = this
      if (th.$refs && th.$refs.form) {
        var form = th.$refs.form
        form.setAttribute('action', th.url)
        form.submit()
        setTimeout(function () { th.resize() }, 10)
      } else setTimeout(function () { th.submitForm() }, 10)
    },
    resize (e) {
      const th = this
      if (window.innerHeight) {
        var iframe = th.$refs.iframe_imprimir
        var container = th.$refs.container
        iframe.setAttribute('height', window.innerHeight + 'px')
        iframe.onload = function (e) {
          e.preventDefault()
          th.showloading = false
        }
        container.style.height = window.innerHeight + 'px'
      } else setTimeout(function () { }, 10)
    }
  },
}
</script>
